import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../constant/routeConstant";
import * as TripPlanningService from '../../../../../service/order/tripPlanningServices';
import { useSelector } from "react-redux";
import Geocode from "react-geocode";

const useDetailDAIntrip = () => {
  const {token} = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  const [order, setOrder] = useState({});
  const [delivAso, setDelivAso] = useState({});
  const [route, setRoute] = useState([]);
  const [depotLat, setDepotLat] = useState(null)
  const [depotLong, setDepotLong] = useState(null)
  const [isSkeletonMaps, setIsSkeletonMaps] = useState(false);
  const [messages, setMessages] = useState('');
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [directions, setDirections] = useState({});
  const [listOrderTrip, setListOrderTrip] = useState([]);
  const [viewDetail, setViewDetail] = useState({});
  const [modalViewDetail, setModalViewDetail] = useState(false);
  const [search, setSearch] = useState([]);
  const [pageListOrder, setPageListOrder] = useState(1);
  const [limitListOrder, setLimitListOrder] = useState(100);
  const [dataSearch, setDataSearch] = useState('');
  const [pageMap, setPageMap] = useState(1);

  const [isViewDetailPhoto, setIsViewDetailPhoto] = useState(false);
  const [photoPath, setPhotoPath] = useState("");

  const _backToDetail = () => {
    navigate(ROUTES.TRIP_PLANNING.DETAIL, { state: { data:location?.state?.data } })
  }

  const _getDepot = async (id) => {
    const { ok, data } = await TripPlanningService.detailDepot(token, id);
    if (ok) {
      setDepotLat(Number(data?.depot_profile?.depot_latitude))
      setDepotLong(Number(data?.depot_profile?.depot_longitude))
    }
  }

  const _getDetailDA = async (id) => {
    const { ok, data, message } = await TripPlanningService.detailInTripPlanning(token, id);

    if (ok) {
      setOrder(data?.order);
      setDelivAso(data?.delivery_associate);

      let list_map = data?.list_maps ? data?.list_maps.map((item) => { 
        return {
          longitude: Number(item?.longitude), 
          latitude: Number(item?.latitude), 
          trip_route_sequence: item?.trip_route_sequence
        }
      }) : [];
      setRoute(list_map);
      setIsSkeletonMaps(true);
    } else {
      setMessages(message);
      setFailedModalOpen(true);
    }
  }

  const results = [];
  const chunkSize = 25;
  const tempArray = [...route];
  let way = [];

  route?.map((el, i) => {
    way.push({
      location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
      stopover: true,
    });
  });

  while (way.length) {
    results.push(way.splice(0, chunkSize));
  }

  let card = [];
  while (tempArray.length) {
    card.push(tempArray.splice(0, chunkSize));
  }

  const directionToMaps = (pg) => {
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    let way = [];

    route?.map((el, i) => {
      way.push({
        location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
        stopover: true,
      });
    });

    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: pg === 1
        ? {
            lat: Number(depotLat),
            lng: Number(depotLong),
          }
        : {
            lat: Number(card[pg - 2][card[pg - 2]?.length - 1].latitude),
            lng: Number(card[pg - 2][card[pg - 2]?.length - 1].longitude),
          },
        destination: card.length >= 1
        ? {
            lat: card[pg - 1][card[pg - 1]?.length - 1]?.latitude,
            lng: card[pg - 1][card[pg - 1]?.length - 1]?.longitude,
          }
        : {
            lat: route[route?.length - 1]?.latitude,
            lng: route[route?.length - 1]?.longitude,
          },
        waypoints: results[pg - 1],
        optimizeWaypoints: true,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result);
          setIsSkeletonMaps(false);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }

  useEffect(() => {
    setPageListOrder(1)
    setLimitListOrder(100)
    const executeAsync = async () => {
      if (route && depotLat && depotLong && window.google) {
        directionToMaps(pageMap);
      }
    };
  
    executeAsync();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[route, depotLong, depotLat, window.google, pageMap]);

  const getListOrderTrip = async (data) => {
    const filter = data ? `order_trip_draft_id eq ${location?.state?.dataDA?.id}, customer_name lk ${data}` : `order_trip_draft_id eq ${location?.state?.dataDA?.id}`;
    const params = { page: pageListOrder, limit: limitListOrder, filter }
    const { ok, list } = await TripPlanningService.listOrderTrip(token,params);

    if (ok) {
      if (list !== null) {
        setListOrderTrip(list);
      } else {
        setListOrderTrip([]);
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      await _getDetailDA(location?.state?.dataDA?.id);
      await _getDepot(location?.state?.dataDA?.depot_id);
      await getListOrderTrip();
    }

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const viewDetailListOrder = async (id) => {
    const { ok, data } = await TripPlanningService.detailOrderList(token, id);
    
    if (ok === true && data !== null) {
      setViewDetail(data);
      setModalViewDetail(true);
    }
  }

  const closeModalView = () => {
    setViewDetail({})
    setModalViewDetail(false);
  }

  const searchListOrder = async (data) => {
    const params = { page: 1, limit: 10, filter: `order_trip_draft_id eq ${location?.state?.dataDA?.id}, customer_name lk ${data}` };

    if (data !== undefined && data !== null) {
      if (data.length >= 3) {
        const { ok, list } = await TripPlanningService.searchListOrderTrip(token, params);
        if (ok && list.length > 0) {
          setSearch(list);
        }
      } else {
        setSearch([]);
      }
    }
  }

  const selectListOrder = (data) => {
    getListOrderTrip(data)
  }

  useEffect(() => {
    getListOrderTrip(dataSearch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dataSearch]);

  const onChangeSearch = (evt) => {
    setDataSearch(evt);
  }

  const handlePaginationMap = (a, b) => {
    setIsSkeletonMaps(true)
    if (a && b) {
      setPageMap(a);

      directionToMaps(a);
      // setLimitMap(b);
    } else {
    }
  };

  const onPreviewPhoto = useCallback((photo) => {
    setPhotoPath(photo);
    setIsViewDetailPhoto(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isViewDetailPhoto, photoPath]);

  const onClosePreviewPhoto = useCallback(() => {
    setPhotoPath("");
    setIsViewDetailPhoto(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isViewDetailPhoto, photoPath]);

  return {
    order,
    delivAso,
    location,
    route,
    isSkeletonMaps,
    messages,
    failedModalOpen,
    depotLat,
    depotLong,
    directions,
    listOrderTrip,
    viewDetail,
    modalViewDetail,
    search,
    card,
    pageMap,
    isViewDetailPhoto,
    photoPath,
    setFailedModalOpen,
    _backToDetail,
    viewDetailListOrder,
    closeModalView,
    searchListOrder,
    selectListOrder,
    onChangeSearch,
    handlePaginationMap,
    onPreviewPhoto,
    onClosePreviewPhoto
  }
}

export default useDetailDAIntrip;